import axiosApiInstanceMain from "../../../../api/axiosApiClient";
import { InternalAPIError } from "../../../../utils/apiErrors";
import { handleApiError } from "../../../../utils/globalErrorHandler";

const MKS_REACT_APP_API_URL = process.env.REACT_APP_CHAT_HISTORY_WRAPPER_URL;

export const saveHistory = async (data) => {
  try {
    const response = await axiosApiInstanceMain.post(
      `${MKS_REACT_APP_API_URL}/history/save`,
      {
        conversationId: data.conversationId,
        conversationShortName: data.conversationShortName,
        conversationDateTime: data.conversationDateTime,
        user_Id: data.user_Id,
        skillId: data.skillId,
        citations: data.citations,
        chatText: data.chatText,
        role: data.role,
        isFailed: data.isFailed,
        lat: data.lat,
        long: data.long,
        userEmail: data.userEmail,
        ModelName: data.ModelName,
        inputTokens: data?.inputTokens,
        outputTokens: data?.outputTokens,
        totalTokens: data?.totalTokens,
        inputCostUsd: data?.inputCostUsd,
        outputCostUsd: data?.outputCostUsd,
        totalCostUsd: data?.totalCostUsd
      }
    );
    if (response.status === 201) {
      return response.data;
    } else {
      handleApiError(new InternalAPIError());
    }
  } catch (ex) {
    console.log(ex);
  }
};

export const getChatHistoryList = async (user_Id, skillId) => {
  try {
    const response = await axiosApiInstanceMain.post(
      `${MKS_REACT_APP_API_URL}/history/get_list`,
      {
        user_Id,
        skillId,
      }
    );
    if (response.status === 200) {
      return response.data;
    } else {
      handleApiError(new InternalAPIError());
    }
  } catch (error) {
    handleApiError(new InternalAPIError());
  }
};

export const getHistoryChat = async (user_Id, conversationId) => {
  try {
    const response = await axiosApiInstanceMain.post(
      `${MKS_REACT_APP_API_URL}/history/get_chat`,
      {
        user_Id,
        conversationId,
      }
    );

    if (response.status === 200) {
      return response.data;
    } else {
      handleApiError(new InternalAPIError());
    }
  } catch (error) {
    handleApiError(new InternalAPIError());
  }
};
